// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"389":"b66eca27","553":"c3e39e0b","857":"5a56ced9","977":"1cadb44b"}[chunkId] + ".chunk.js";
};